import {useFormContext} from '@yandex-delivery/form'
import {useCallback} from 'react'

import {i18n} from 'src/shared/config'
import {useBlocksVisibilityStatesContext} from 'src/shared/contexts'
import {OrderEventGoal, useFormUserEventHandler} from 'src/shared/hooks'

import type {Props} from './types'

function useContactsCaption({name}: Pick<Props, 'name'>) {
  const {watch} = useFormContext()
  const names = {
    phone: `${name}.phone`,
    name: `${name}.name`,
    email: `${name}.email`,
    isSmsConfirmationEnabled: `${name}.isSmsConfirmationEnabled`,
  } as const

  const pointContactsEmail = watch(names.email)
  const pointContactsName = watch(names.name)
  const isSmsConfirmationEnabled = watch(names.isSmsConfirmationEnabled)

  const helperTextValues: (string | undefined)[] = [pointContactsName, pointContactsEmail]

  if (isSmsConfirmationEnabled) {
    helperTextValues.push(i18n('cargo.create.contact.confirm_by_sms', 'Подтвердить по СМС'))
  }

  return {
    caption: helperTextValues.filter(Boolean).join(', '),
    names,
  }
}

export function usePointContactsExpress({name, pointType}: Pick<Props, 'name' | 'pointType'>) {
  const {caption, names} = useContactsCaption({name})
  const {getIsVisible, setVisible, setInvisible} = useBlocksVisibilityStatesContext()
  const handleReachGoal = useFormUserEventHandler()

  const isContactDetailsVisible = getIsVisible(name)

  const contactDetailsVisibilityHandler = useCallback(() => {
    if (isContactDetailsVisible) {
      setInvisible(name)
    } else {
      setVisible(name)
    }
  }, [isContactDetailsVisible, name, setInvisible, setVisible])

  const handlePhoneInputFocus = handleReachGoal.bind(
    null,
    pointType === 'a' ? OrderEventGoal.AddressFromPhoneClick : OrderEventGoal.AddressToPhoneClick,
  )

  return {
    isContactDetailsVisible,
    contactDetailsVisibilityHandler,
    contactsCaption: caption,
    handlePhoneInputFocus,
    names,
  }
}
